module.exports = __webpack_public_path__ + "img/emoji_5.5b20263a.png";